import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcadmin/adminlogin/AdminLoginPage.css";
import AppContext from "../../../context/AppContext";
import { Spinner } from "react-bootstrap";
import axios from "axios";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const {
    baseUrl, setLoggedInUser, setAuthToken, setUserType, loggedInUser, userType, authLoading,} = useContext(AppContext);

  const [email,       setEmail]       = useState("");
  const [password,    setPassword]    = useState("");
  const [error,       setError]       = useState("");
  const [loading,     setLoading]     = useState(false);
  const [visible,     setVisible]     = useState(false);
  const [showPass,    setShowPass]    = useState(false);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  // Agar AppContext ne already token se admin ko load kar liya hai,
  // to login form dikhane ki zaroorat nahi — seedha dashboard.
  useEffect(() => {
    if (authLoading) return;
    if (loggedInUser && userType === "admin") {
      navigate("/admin/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser, userType, authLoading]);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/adminLogin`, formData)
      .then((res) => {
        setLoading(false);

        if (res.data.success === true) {
          // Sirf context mein save karo — token persist karna
          // (agar zaroori ho) AppContext khud internally handle karega.
          setAuthToken(res.data.token);
          setUserType("admin");
          setLoggedInUser(res.data.admin);
          navigate("/admin/dashboard");
        } else {
          setError(res.data.message || "Login failed. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        const backendMsg =
          error.response?.data?.message ||
          error.response?.data?.error   ||
          "Something went wrong. Please try again.";
        setError(backendMsg);
      });
  };

  return (
    <>
      {authLoading ? (
        <div style={{
          display:         "flex",
          alignItems:      "center",
          justifyContent:  "center",
          minHeight:       "100vh",
          backgroundColor: "var(--primary-color)",
        }}>
          <Spinner />
        </div>
      ) : (
        <div className={`gcAdmin-login-page ${visible ? "gcAdmin-login-page--visible" : ""}`}>
          <div className={`gcAdmin-login-card ${visible ? "gcAdmin-login-card--visible" : ""}`}>

            {/* <div className="gcAdmin-login-icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
                stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div> */}

            <h2 className="gcAdmin-login-title">Admin Login</h2>
            <p  className="gcAdmin-login-subtitle">Access the admin control panel</p>

            <form className="gcAdmin-login-form" onSubmit={handleLogin} noValidate>

              <div className="gcAdmin-login-field">
                <input
                  className={`gcAdmin-login-input ${error ? "gcAdmin-login-input--error" : ""}`}
                  type="email"
                  placeholder="Admin Email"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setError(""); }}
                  autoComplete="email"
                  disabled={loading}
                />
              </div>

              <div className="gcAdmin-login-field gcAdmin-login-field--pass">
                <input
                  className={`gcAdmin-login-input ${error ? "gcAdmin-login-input--error" : ""}`}
                  type={showPass ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(""); }}
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="gcAdmin-login-eye"
                  onClick={() => setShowPass(s => !s)}
                  tabIndex={-1}
                  aria-label={showPass ? "Hide password" : "Show password"}
                >
                  {showPass ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>

              {error && (
                <p className="gcAdmin-login-error">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8"  x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {error}
                </p>
              )}
              <div className="gcAdmin-login-forgot-row">
                <button
                  type="button"
                  className="gcAdmin-login-forgot"
                  onClick={() => navigate("/admin/forgot-password")}
                >
                  Forgot password?
                </button>
              </div>

              <button
                type="submit"
                className={`gcAdmin-login-btn ${loading ? "gcAdmin-login-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? (
                  <span className="gcAdmin-login-spinner" />
                ) : (
                  "Login"
                )}
              </button>

            </form>

            <button
              className="gcAdmin-login-back"
              onClick={() => navigate("/")}
              type="button"
            >
              ← Back to Home
            </button>

          </div>
        </div>
      )}
    </>
  );
};

export default AdminLoginPage;